import React from "react";
import { GiftIcon, CheckCircle2Icon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { CtaButton } from "./CtaButton";
import { bonuses } from "../data/content";
export function Bonuses() {
  return <section className="w-full bg-navy px-0 py-16 sm:px-5 sm:py-20" data-id="element-59" data-mp="aujyg6bo7z1d">
      <div className="px-5 sm:px-0" data-id="element-60" data-mp="ftefb2q2vdiu">
        <SectionHeading tone="dark" eyebrow="5 Exclusive Bonuses — Included Free" title="Get These Five Additional Tools with Your Purchase" data-id="element-61" data-mp="fsbsb5vvlv87" />
      </div>

      <div className="mx-auto mt-10 max-w-3xl space-y-8" data-id="element-62" data-mp="5xjpnnnfsi6k">
        {bonuses.map(b => <article key={b.number} className="overflow-hidden bg-white sm:rounded-3xl" data-id="element-63" data-mp="3o3696f3uh0g9">
            <div className="flex items-center justify-between gap-3 bg-alert px-5 py-3" data-id="element-64" data-mp="3t1himoq898xy">
              <span className="flex items-center gap-2 font-display text-lg font-black uppercase text-white" data-id="element-65" data-mp="1mb9z79xbrynl">
                <GiftIcon className="h-5 w-5" aria-hidden="true" data-id="element-66" data-mp="1r80evw57ws8h" />
                Bonus #{b.number}
              </span>
              <span className="text-sm font-bold text-white" data-id="element-67" data-mp="3iclo5tyzymyv">
                <s className="opacity-80" data-id="element-68" data-mp="3dg4vcmgurkfg">{b.value}</s> → FREE
              </span>
            </div>
            <img src={b.image} alt={`${b.title} mockup`} className="block w-full" loading="lazy" data-id="element-69" data-mp="3r702nubpdtgx" />
            <div className="px-5 pb-7 pt-2 sm:px-8" data-id="element-70" data-mp="3n4wogxxngary">
              <h3 className="font-display text-2xl font-black leading-tight text-navy sm:text-3xl" data-id="element-71" data-mp="3n7iu2s0zcg7j">{b.title}</h3>
              <p className="mt-1 text-sm font-bold text-cta" data-id="element-72" data-mp="2ughbsi1zq4js">Reference Value: {b.value} — Included FREE</p>
              <p className="mt-4 text-base leading-relaxed text-muted" data-id="element-73" data-mp="38g0ir7j2f9ui">{b.intro}</p>
              <p className="mt-5 text-sm font-extrabold uppercase tracking-wide text-navy" data-id="element-74" data-mp="33h5nv77tpuu1">{b.label}</p>
              <ul className="mt-3 space-y-2.5" data-id="element-75" data-mp="nq1aewy3yyrd">
                {b.items.map(item => <li key={item} className="flex gap-3 text-base leading-snug text-navy" data-id="element-76" data-mp="nruh2c8q1izd">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-77" data-mp="itavwe1ycb82" />
                    {item}
                  </li>)}
              </ul>
              <p className="mt-5 rounded-xl bg-canvas p-4 text-sm leading-relaxed text-muted" data-id="element-78" data-mp="3hk3zcpv2kkqc">{b.outro}</p>
            </div>
          </article>)}
      </div>

      <div className="mt-12 px-5 sm:px-0" data-id="element-79" data-mp="3qhmp27jnrn8k">
        <CtaButton tone="dark" data-id="element-80" data-mp="3qgbm29y1ejii">Yes! Give Me All Five Bonuses</CtaButton>
      </div>
    </section>;
}